import type { DirectoryField } from '@/modules/counterparty/counterparty-master/consts/directory.const.ts';

export class DirectoryNameDuplicateError extends Error {
  readonly field: DirectoryField;

  constructor(field: DirectoryField) {
    super(`Duplicate ${field} name`);
    this.name = 'DirectoryNameDuplicateError';
    this.field = field;
  }
}

export function normalizeDirectoryName(name: string) {
  return name.trim().toLocaleLowerCase();
}

export function findDirectoryNameDuplicate<T extends { id: number; name: string }>(
  items: T[],
  name: string,
  excludeId?: number | null
) {
  const normalized = normalizeDirectoryName(name);

  if (!normalized) {
    return undefined;
  }

  return items.find(
    (item) => (excludeId == null || Number(item.id) !== excludeId) && normalizeDirectoryName(item.name) === normalized
  );
}
